import { render, staticRenderFns } from "./RegimenHeaderEdit.vue?vue&type=template&id=6bb5ce97"
import script from "./RegimenHeaderEdit.vue?vue&type=script&lang=js"
export * from "./RegimenHeaderEdit.vue?vue&type=script&lang=js"
import style0 from "./RegimenHeaderEdit.vue?vue&type=style&index=0&id=6bb5ce97&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports